'use client';

import { Flex, FlexProps } from '@chakra-ui/react';
import type { MouseEvent, MouseEventHandler, PropsWithChildren } from 'react';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { PrerenderedHTML } from '@ifixit/prerendered-html';

export interface RibbonBannerData {
   title: string;
   displayText: string;
}

export interface RibbonBannerProps {
   ribbon: RibbonBannerData | null;
   page: string;
   onClick?: MouseEventHandler;
}

export function RibbonBanner({
   ribbon,
   page,
   onClick,
   ...flexProps
}: PropsWithChildren<RibbonBannerProps> & FlexProps) {
   if (!ribbon) {
      return null;
   }

   return (
      <Flex
         as="section"
         bgColor="brand.500"
         color="white"
         p={4}
         alignItems="center"
         justifyContent="center"
         textAlign="center"
         className="piwikTrackContent"
         minHeight="72px"
         fontSize="16px" // FIXME: temp PHP/NextJS sync
         {...flexProps}
      >
         <PrerenderedHTML
            color="white"
            onClick={event => {
               trackRibbonBannerLinkClick(ribbon, page, event);
               onClick?.(event);
            }}
            sx={{
               p: { marginY: 0 },
               strong: { color: 'inherit' },
               a: { color: 'inherit', textDecoration: 'underline', whiteSpace: 'nowrap' },
               lineHeight: '1.25', // tighten multi-line text
            }}
            html={ribbon.displayText}
            data-content-name="Ribbon Banner"
            data-content-piece={`Ad: ${ribbon.title}`}
         />
      </Flex>
   );
}

function trackRibbonBannerLinkClick(
   ribbon: RibbonBannerData,
   page: string,
   event: MouseEvent
): void {
   const element = event.target;
   if (element instanceof HTMLAnchorElement && element.href) {
      trackAnalyticsCustomEvent({
         eventCategory: 'Ribbon Banner',
         eventAction: `${ribbon.title} - Link - Clicked`,
         eventName: page,
      });
   }
}
